<template>
  <div class="engagement">
    <div class="engagement-info">
      <div class="social-media-right-part forMobile">
        <img
          v-motion
          src="img/Demo_content_01-01-01-01.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>

      <div class="social-media-left-part">
        <h4>Engagement</h4>
        <h1>Engagement Tools and Notifications for Fans</h1>

        <div class="social-media-logos">
          <img src="img/instagram-logo.png" alt="" />
          <img src="img/tiktok-logo.png" alt="" />
          <img src="img/youtube-logo.png" alt="" />
          <img src="img/spotify-logo.svg" alt="" />
          <img src="img/zoom-min.png" alt="" />
        </div>

        <li class="first-list-item">
          <p>
            Automated notifications and updates to fans and members makes
            managing your memberships easy.
          </p>
        </li>
        <li class="first-list-item">
          <p>
            'Blast' out exclusive content to your fans with easy integrations to
            Youtube, Soundcloud, Zoom and more.
          </p>
        </li>
      </div>

      <div class="social-media-right-part forWeb">
        <img
          v-motion
          src="img/Demo_content_01-01-01-01.png"
          alt=""
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.forMobile {
  display: none;
}

.engagement {
  width: 100%;
  background-color: #f3f7f8;
}

.engagement-info {
  width: 71rem;
  margin: auto;
  padding-top: 5rem;
  padding-bottom: 5rem;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  border-left: 2px solid white;
}

.social-media-left-part h4 {
  font-weight: 700;
  font-size: 1.5rem;
  padding-top: 1rem;
  padding-left: 25px;
  padding-right: 20px;
  color: #ff5f8f;
}

.social-media-left-part h1 {
  line-height: 1.2;
  font-size: 4rem;
  font-weight: 800;
  margin-left: -2px;
  padding-left: 1.45rem;
  border-left: 2px solid #ff5f8f;
}

.social-media-logos {
  width: 50%;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  padding-left: 1.45rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.social-media-logos img {
  width: 70%;
}

.social-media-left-part li {
  width: 100%;
  align-items: center;
  font-size: 1rem;
  top: -10rem;
  margin-bottom: 20px;
  margin-left: 1.45rem;
  margin-right: 30px;
  padding: 0px 20px 0px 40px;
  list-style: none;
  background-image: url('/img/check-list-cc.svg');
  background-repeat: no-repeat;
  background-position: 0% 20%;
  background-size: 1rem;
}

.social-media-left-part p {
  line-height: 1.5;
  font-weight: 500;
  opacity: 0.6;
}

.social-media-right-part {
  width: 100%;
  margin: auto;
}

.social-media-right-part img {
  width: 80%;
  margin: auto;
  display: block;
}

@media only screen and (max-width: 1400px) {
  .engagement-info {
    width: 60rem;
  }
}

@media only screen and (max-width: 1050px) {
  .forMobile {
    display: block;
  }

  .forWeb {
    display: none;
  }

  .engagement-info {
    width: 40rem;
    grid-template-columns: 1fr;
  }

  .social-media-right-part img {
    width: 63%;
    margin: auto;
    display: block;
  }
}

@media only screen and (max-width: 650px) {
  .engagement-info {
    gap: 1rem;
    width: 90%;
    border-left: none;
  }

  .social-media-left-part h4 {
    font-size: 1rem;
    padding-left: 0;
    margin-left: 0;
  }

  .social-media-left-part h1 {
    font-size: 2rem;
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-logos {
    margin-left: 0;
    padding-left: 0;
  }

  .social-media-right-part {
    width: 100%;
  }

  .social-media-right-part img {
    width: 90%;
  }

  .social-media-left-part li {
    margin-left: 0;
  }
}
</style>
